export enum SeatGroupSalesMode {
  Together = 1,
  Separately = 2,
}
